import { Card, CardContent, Input } from '@/components/ui';
import { OkdocScenarioProfileEditor } from '@/components/features/templates/OkdocScenarioProfileEditor';
import { OkdocLandingDefinitionPreview } from '@/features/okdoc/admin/OkdocLandingDefinitionPreview';
import { OkdocSubmitFlowProfileEditor } from '@/features/okdoc/admin/OkdocSubmitFlowProfileEditor';
import type { OkdocScenarioProfile } from '@/features/okdoc/types';
import type { OkdocLandingDefinition } from '@/types/okdocLandings';
import { createDefaultOkdocProfile } from '@/features/okdoc/utils/scenarioProfile';

interface OkdocLandingDefinitionEditorProps {
  tenantId?: string;
  tenantName: string;
  tenantSlug?: string;
  value: OkdocLandingDefinition;
  onChange: (value: OkdocLandingDefinition) => void;
}

export function OkdocLandingDefinitionEditor({
  tenantId,
  tenantName,
  tenantSlug,
  value,
  onChange,
}: OkdocLandingDefinitionEditorProps) {
  const updateDefinition = (patch: Partial<OkdocLandingDefinition>) => {
    onChange({ ...value, ...patch });
  };

  const updateScenarioProfile = (scenarioProfile?: OkdocScenarioProfile) => {
    updateDefinition({
      scenario_profile: scenarioProfile || createDefaultOkdocProfile(String(value.flow || 'recommendations')),
    });
  };

  const preview = (
    <OkdocLandingDefinitionPreview
      flow={String(value.flow || 'appointment_confirmation')}
      tenantName={tenantName}
      tenantSlug={tenantSlug}
      scenarioProfile={value.scenario_profile}
    />
  );

  return (
    <div className="space-y-4">
      <Card>
        <CardContent className="space-y-4 pt-6">
          <div className="grid gap-4 md:grid-cols-2">
            <Input label="Название definition" value={value.name || ''} onChange={(e) => updateDefinition({ name: e.target.value })} />
            <Input label="Flow" value={String(value.flow || '')} onChange={() => undefined} disabled />
          </div>

          <Input
            label="Prompt для SMS-кнопки"
            value={value.prompt_text || ''}
            onChange={(e) => updateDefinition({ prompt_text: e.target.value })}
            placeholder="Открыть рекомендации и полезные материалы"
          />
        </CardContent>
      </Card>

      {value.flow === 'recommendations' ? (
        <OkdocScenarioProfileEditor
          value={value.scenario_profile}
          onChange={updateScenarioProfile}
          allowManualCTAs
          alwaysEnabled
          previewContent={preview}
          tenantId={tenantId}
        />
      ) : (
        <OkdocSubmitFlowProfileEditor
          flow={value.flow === 'feedback_collection' ? 'feedback_collection' : 'appointment_confirmation'}
          value={value.scenario_profile}
          onChange={updateScenarioProfile}
          previewContent={preview}
        />
      )}
    </div>
  );
}
